// PlatformForm.tsx
import React from "react";

import { Business } from "0.Mine/3.Interfaces/business";

import { usePlatformFormLogic } from "../../Logic/BasicInfo/Platform";
import PlatformFormUI from "../../UI/PlatformFormUI";

interface PlatformFormProps {
  website: string;
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

const PlatformForm: React.FC<PlatformFormProps> = ({
  website,
  updateBusinessData,
  businessData,
}) => {
  const {
    platformName,
    platformType,
    setPlatformName,
    setPlatformType,
    ragioneSociale,
    setRagioneSociale,
  } = usePlatformFormLogic({ website, updateBusinessData, businessData });

  return (
    <PlatformFormUI
      platformName={platformName}
      platformType={platformType}
      onPlatformNameChange={setPlatformName}
      onPlatformTypeChange={setPlatformType}
      ragioneSociale={ragioneSociale}
      onRagioneSocialeChange={setRagioneSociale}
    />
  );
};

export default PlatformForm;
